import { FeatureVisibility, IFeature } from '@principle-theorem/feature-flags';

export enum CalendarPermissions {
  CalendarEventsManage = 'calendar-events.manage',
}

/**
 * Gates the schedule routes and the Calendar sidebar link by feature flag only.
 * Those gates also demand every permission on their feature, and
 * `calendar-events.manage` restricts managed calendar events, not access to the
 * calendar. It is registered under `CALENDAR_FEATURE` because feature flags are
 * resolved by reference.
 */
export const CALENDAR_ROUTE_FEATURE: IFeature = {
  label: 'calendars',
  visibility: FeatureVisibility.Stable,
  permissions: [],
};

export const CALENDAR_FEATURE: IFeature = {
  ...CALENDAR_ROUTE_FEATURE,
  permissions: [
    {
      value: CalendarPermissions.CalendarEventsManage,
      description:
        'User can create, edit, move and delete calendar events (meetings, pre-blocks, breaks, leave, misc and practice closed)',
    },
  ],
  features: [CALENDAR_ROUTE_FEATURE],
};
